<template>
  <div>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-xl-only"
    >
      <el-form-item style="float: right">
        <!-- <el-link
          type="primary"
          :underline="false"
          @blur="collapse = !collapse"
          style="margin-right: 10px"
          >{{ collapse ? "折叠" : "展开" }}</el-link
        > -->
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <!-- <el-form-item label="店铺" class="first-lable">
        <el-select v-model="form.storeCode" filterable>
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px; padding-left: 10px"
        >
        </el-switch>
      </el-form-item> -->
      <el-form-item label="型号" prop="bigModel">
        <!-- <el-input
          v-model="form.bigModel"
          placeholder="请输入型号信息搜索"
        ></el-input> -->
        <el-autocomplete
          class="form-input"
          v-model="form.bigModel"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(2)"
          @blur="getCategoryMappingBigModel(true)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="类别">
        <el-autocomplete
          class="form-input"
          v-model="form.category"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(0)"
          @blur="getCategoryMappingBigModel(true)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="风格">
        <el-autocomplete
          class="form-input"
          v-model="form.style"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(1)"
        ></el-autocomplete>
      </el-form-item>
      <!-- <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          <el-form-item label="类别">
            <el-select v-model="form.storeId" filterable placeholder="全部">
              <el-option label="全平台" value="" />
              <el-option
                v-for="item in useObjectList"
                :label="item.name"
                :key="item.id"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风格">
            <el-select v-model="form.storeId" filterable placeholder="全部">
              <el-option label="全平台" value="" />
              <el-option
                v-for="item in useObjectList"
                :label="item.name"
                :key="item.id"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </transition> -->
    </el-form>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-lg-and-down"
    >
      <el-form-item style="float: right">
        <!-- <el-link type="primary" :underline="false" @blur="collapse = !collapse;" style="margin-right: 10px;">{{collapse?'折叠':'展开'}}</el-link> -->
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <!-- <el-form-item label="店铺" class="first-lable">
        <el-select v-model="form.storeCode" filterable>
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px; padding-left: 10px"
        >
        </el-switch>
      </el-form-item> -->
      <el-form-item label="型号" prop="goodsCode">
        <!-- <el-input
          v-model="form.bigModel"
          placeholder="请输入型号信息搜索"
        ></el-input> -->
        <el-autocomplete
          class="form-input"
          v-model="form.bigModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(2)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="类别">
        <el-autocomplete
          class="form-input"
          v-model="form.category"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(0)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="风格">
        <el-autocomplete
          class="form-input"
          v-model="form.style"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(1)"
        ></el-autocomplete>
      </el-form-item>
      <!-- <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          
        </div>
      </transition> -->
    </el-form>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import { debounce } from "@/utils/index";
import moment from "moment";
export default {
  model: {
    prop: "formData",
    event: "input",
  },
  props: ["formData"],
  data() {
    return {
      collapse: false,
      form: {},
      useObjectList: [],
      optionsn: [],
      inputData: [],
      dataRange: false,
      inputIndex: 9,
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    collapse(val) {
      this.$emit("onCollapse", val);
    },
  },
  mounted() {
    this.getOptionsn();
  },
  methods: {
    onSearch() {
      if (!this.form.bigModel) {
        this.$message.error("型号信息未填写，请填写后再搜索");
        return;
      } else if (!this.form.category) {
        this.$message.error("类别信息未填写，请填写后再搜索");
        return;
      }
      this.$emit("search", this.form);
    },
    onReset() {
      this.form = {
        storeCode: this.form.storeCode,
      };
      this.getOptionsn()
      this.$nextTick((_) => {
        this.$emit("reset");
      });
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index
      if (index == 0) {
        this.inputData = this.optionsn.category;
      } else if (index == 1) {
        this.inputData = this.optionsn.style;
      } else {
        this.inputData = this.optionsn.bigModel;
      }
    },
    queryStringFales(queryString,cb) {
      let data = {
        categoryName: this.form.category,
        smallModel: this.form.smallModel,
        bigModel: this.form.bigModel,
        };
      this.$q.intelligentRecom
        .optionsn({ data: data})
        .then((res) => {
          this.optionsn = res.data;
          if (this.inputIndex == 0) {
          this.inputData = this.optionsn.category;
        } else if (this.inputIndex == 2) {
          this.inputData = this.optionsn.bigModel;
        }
        let data = this.inputData;
        if (!data || !data.allOptions) {
          cb([]);
          return;
        }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      console.log(results);
      // 调用 callback 返回建议列表的数据
      cb(results);
        })
        .finally((_) => {
          
        });
    },

    queryStringTrue(queryString, cb) {
      let data = this.inputData;
      if (!data || !data.allOptions) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      if(this.inputIndex == 0) {
        this.optionsn.bigModel = []
        this.getCategoryMappingBigModel()
      }else if(this.inputIndex == 2 && queryString && queryString.length >2) {
        this.optionsn.category = []
        this.getCategoryMappingBigModel()
      }
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

     querySkuList(queryString, cb) {
      if(queryString) {
        this.queryStringTrue(queryString, cb)
      }else {
        this.queryStringFales(queryString, cb)
      }
    },
    getOptionsn(data) {
      this.$q.intelligentRecom.optionsn({data:data || {}}).then((res) => {
        this.$nextTick(_=>{
          this.optionsn = res.data;
        })
      });
    },
    getCategoryMappingBigModel(type) {
       setTimeout(_=>{
         let data = {
          categoryName: this.form.category,
          bigModel: this.form.bigModel,
        }
        this.getOptionsn(data)
       },type ? 200 : 0)
    },
    // salesGetStore() {
    //   this.$q.intelligentRecom.getStore({}).then((res) => {
    //     this.useObjectList = res.data;
    //     if (res.data[0].whetherDef == "1") {
    //       this.$set(this.form,'storeCode',res.data[0].code)
    //     }
    //   });
    // },
  },
};
</script>
<style lang="stylus" scoped>
>>> .el-form {
  width: 100%;
  margin-top: 10px;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

>>> .el-form-item__label {
  width: 50px !important;
}

.search-header-collapse {
  // position absolute
  background-color: #ffffff;
  width: 100%;
  left: 0px;
  padding: 5px 0px 0px 0;
  margin-top: -5px;
  box-sizing: border-box;
  // z-index 999
  // box-shadow 0px 5px 5px rgba(0,0,0,.1)
}

>>> .table-input input {
  height: 18px;
  line-height: 18px;
  padding: 0 10px;
  text-align: right;
  width: 45px;
}
</style>